export interface BookService {
  id: number;
  customer: string;
  creatDate: string;
  endDate: string;
  receipt: string;
  status: string;
}

export const bookServiceDefault: BookService = {
	id: 0,
	customer: "",
	creatDate: "",
	endDate: "",
	receipt: "",
	status: "",
};

export interface Service {
  name: string;
  price: string;
  note: string;
}

export interface Car {
  image: string;
  title: string;
  status: string;
  note: string;
}

export interface BookServiceQueryParams {
  id?: string;
  status?: number;
  skip: number;
  take: number;
  startDate: string;
  endDate: string;
}

export interface ShowDetailsForm {
  onOpen(): void;
}
